/**
 * credits.js — авторство в подвале приложения.
 *
 * Автор программы — Михмель Андрей Вячеславович, врач-кардиолог.
 * Этот модуль гарантированно проставляет строку авторства в нижнюю панель
 * (.bottombar-right) при запуске — даже если index.html когда-нибудь заменят.
 */

import { log } from '../utils/logger.js';

export const AUTHOR = 'Михмель Андрей Вячеславович, врач-кардиолог';

/**
 * Телефоны автора в подвале. [10.19.29]
 *
 * Хранятся ПАРОЙ: как показывать человеку и как набирать. Показ — привычный
 * русский вид с пробелами и скобками; набор — только цифры с плюсом, потому
 * что схема tel: пробелы и скобки допускает, но некоторые обработчики звонков
 * на них спотыкаются, а +7XXXXXXXXXX понимают все.
 *
 * Нажатие работает и в Windows, и на телефоне: браузер отдаёт ссылку tel:
 * системе, а та зовёт назначенное приложение (в Windows это «Ваш телефон» /
 * Skype / Teams — какое приложение выбрано в системе, то и откроется; если ни
 * одного не назначено, Windows предложит выбрать). На смартфоне открывается
 * набор номера.
 */
export const PHONES = Object.freeze([
  { показ: '+7 (928) 775-55-92', набор: '+79287755592' },
  { показ: '+7 (928) 131-99-13', набор: '+79281319913' },
]);

function _apply() {
  const right = document.querySelector('.bottombar-right');
  if (!right) return false;
  if (right.querySelector('.app-author')) return true;
  const span = document.createElement('span');
  span.className = 'app-author';
  span.style.cssText = 'color:var(--text-dim,#8aa)';
  span.append(document.createTextNode('Автор — ' + AUTHOR + ' · '));
  // [10.19.29] Телефоны — настоящими ссылками, а не текстом: по нажатию
  // Windows передаёт номер приложению для звонков, телефон открывает набор.
  PHONES.forEach((тел, i) => {
    const a = document.createElement('a');
    a.className = 'app-author-phone';
    a.href = 'tel:' + тел.набор;
    a.textContent = тел.показ;
    a.title = 'Позвонить ' + тел.показ;
    a.style.cssText = 'color:var(--accent,#4a9eff);text-decoration:none;white-space:nowrap;';
    span.appendChild(a);
    if (i < PHONES.length - 1) span.append(document.createTextNode(', '));
  });
  const copy = Array.from(right.querySelectorAll('span')).find(s => /©/.test(s.textContent || ''));
  if (copy) right.insertBefore(span, copy); else right.appendChild(span);
  return true;
}

export function initCredits() {
  try {
    if (!_apply()) {
      // DOM ещё строится — повторяем несколько раз.
      let tries = 0;
      const t = setInterval(() => { if (_apply() || ++tries > 20) clearInterval(t); }, 500);
    }
    log.info('[Credits] Автор программы — ' + AUTHOR);
  } catch (e) { /* некритично */ }
}

export default { initCredits, AUTHOR, PHONES };
